import React from 'react';

import CancellationPolicyManagement from '../../../components/siteadmin/CancellationPolicy/CancellationPolicyManagement';

import { useQuery } from '@apollo/client';
import { getCancellationPolicies } from '../../../lib/graphql';

const CancellationPolicies = () => {

    const { data, loading } = useQuery(getCancellationPolicies, {
        fetchPolicy: 'network-only',
        ssr: false
    });

    return (
        <CancellationPolicyManagement
            data={data?.getCancellationPolicies}
            loading={loading}
        />
    );
};

export default CancellationPolicies;